import React from 'react';

const linkTo = (href, text) =>
  text ? (
    <a href={href} style={{ color: '#1a73c8', textDecoration: 'underline' }}>
      {text}
    </a>
  ) : (
    <span>—</span>
  );

const apiRolePermissionConfig = {
  name: 'API Role Permission',
  endpoint: '/internal_admin/admin_kit/api_role_permissions',
  modelKey: 'rbac_api_role_permission',

  columns: [
    { name: 'permission_name', title: 'Permission', type: 'link' },
    { name: 'api_role_name', title: 'API Role' },
    { name: 'created_by_name', title: 'Created By' },
    { name: 'created_at', title: 'Created' },
  ],

  filters: [
    { name: 'q[permission_name_cont]', label: 'Permission' },
    { name: 'q[api_role_name_cont]', label: 'API Role' },
  ],

  attributes: [
    { name: 'id', label: 'ID' },
    {
      name: 'permission_name',
      label: 'Permission',
      render: (r) =>
        linkTo(
          `/internal_admin/admin_kit/permissions/${r.permission_id}`,
          r.permission_name,
        ),
    },
    { name: 'permission_description', label: 'Permission Description' },
    {
      name: 'api_role_name',
      label: 'API Role',
      render: (r) =>
        linkTo(
          `/internal_admin/admin_kit/api_roles/${r.api_role_id}`,
          r.api_role_name,
        ),
    },
    { name: 'created_by_name', label: 'Created By' },
    { name: 'created_at', label: 'Created At' },
    { name: 'updated_at', label: 'Updated At' },
  ],
};

export default apiRolePermissionConfig;
